import type { ReactElement } from 'react';
import { formatiereProzent, prozentAnteil } from '@mcikm-vote/shared';
import type { ErgebnisOption } from '@mcikm-vote/shared';

/**
 * Horizontale Ergebnisbalken (§18.1, §18.2).
 *
 * Die Prozentwerte kommen aus der geteilten Funktion `prozentAnteil` — derselben, die später PDF
 * und CSV verwenden (S6). Ein eigener Rundungsweg hier hätte über kurz oder lang zu Abweichungen
 * zwischen Anzeige und Ausdruck geführt.
 *
 * Absolute Zahl **und** Prozentwert stehen als Text daneben. Der Balken ist eine Zugabe, kein
 * Träger der Aussage (§21).
 */
export function Ergebnisbalken({
  optionen,
  abgegebeneStimmen,
}: {
  optionen: ErgebnisOption[];
  abgegebeneStimmen: number;
}): ReactElement {
  return (
    <ul className="flex flex-col gap-3">
      {optionen.map((option) => {
        const anteil = prozentAnteil(option.stimmen, abgegebeneStimmen);

        return (
          <li key={option.optionId} className="flex flex-col gap-1">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <span className={option.art === 'regulaer' ? 'font-medium' : 'font-medium italic'}>
                {option.text}
              </span>
              <span className="text-text-gedaempft text-sm">
                {option.stimmen} {option.stimmen === 1 ? 'Stimme' : 'Stimmen'} ·{' '}
                {formatiereProzent(anteil)}
              </span>
            </div>

            <div
              className="bg-flaeche-gedaempft h-3 w-full overflow-hidden rounded-full"
              role="img"
              aria-label={`${option.text}: ${option.stimmen} Stimmen, ${formatiereProzent(anteil)}`}
            >
              <div className="bg-akzent h-full rounded-full" style={{ width: `${anteil}%` }} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
